import './TableHeader.css';

/**
 * Table header component for scheduler results table
 * Displays column headers for desktop layout
 * 
 * Columns:
 * - Expand button
 * - Stage name
 * - Date
 * - Time
 * - Status
 * - User
 * - Edit date
 * - Actions
 * 
 * @returns JSX element containing the table header row
 */
export function TableHeader() {
  return (
    <div className="scheduler-table-header">
      <div className="scheduler-table-header-row">
        <div className="scheduler-table-header-cell scheduler-col-expand"></div>
        <div className="scheduler-table-header-cell scheduler-col-stage">Назва етапу</div>
        <div className="scheduler-table-header-cell scheduler-col-date">Дата</div>
        <div className="scheduler-table-header-cell scheduler-col-time">Час</div>
        <div className="scheduler-table-header-cell scheduler-col-status">Статус</div>
        <div className="scheduler-table-header-cell scheduler-col-user">Користувач</div>
        <div className="scheduler-table-header-cell scheduler-col-edit-date">Дата редагування</div>
        <div className="scheduler-table-header-cell scheduler-col-actions">Дії</div>
      </div>
    </div>
  );
}
